import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";
import BottomBar from "examples/Navbars/BottomBar";
import routes from "routes"; // Adjust the import path as necessary
import BedtimeOutlinedIcon from "@mui/icons-material/BedtimeOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import user_manual from "assets/images/user_mannual.pdf";
const getRouteName = (path) => {
  for (const route of routes) {
    if (route.route === path) {
      return route.name; // Return the name if it matches
    }
    if (route.children) {
      for (const child of route.children) {
        if (child.route === path) {
          return child.name; // Return the child's name if it matches
        }
      }
    }
  }
  return "View Application"; // Return a default name if no match is found
};
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
import { Navigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Dashboard from "layouts/dashboard";
const BASE_URL = process.env.REACT_APP_BASE_URL;
function DashboardNavbar({ absolute, light, isMini }) {
  
  const userString = sessionStorage.getItem("user");
  if (!userString) {
    // If user is not logged in, redirect to login page
    window.location.href = "https://portal.bzu.edu.pk/login";
    return null; // Prevent rendering the navbar
  }
  let user;

  try {
    user = JSON.parse(userString);
  } catch {
  }

  if (user?.role_id === 4 || user?.role === "admission-applicant") {
    // Immediate redirect BEFORE rendering anything
    return <Navigate to="/" replace />;
  }
  const navigate = useNavigate();
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
  } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const currentPath = useLocation().pathname; // Get the current path
  const currentRouteName = getRouteName(currentPath);

  useEffect(() => {
     const userString = sessionStorage.getItem("user");
    let user;
    try {
      user = JSON.parse(userString);
    } catch {
      user = null;
    }
if (user?.role?.toLowerCase().includes("staff"))
  {
    fetch(`${BASE_URL}/applicant/check_ip_allowed`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application',
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        if (!data.allowed) {
          alert('Access denied: You are not accessing from an allowed IP address.');
          window.location.href = 'https://portal.bzu.edu.pk/logout';
        }
      })
      .catch(error => {
        console.error('Error checking allowed IP:', error);
      });
  }
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }
    window.addEventListener("scroll", handleTransparentNavbar);

    handleTransparentNavbar();
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);

  const handleCloseMenu = () => setOpenMenu(false);
  const [anchorEl, setAnchorEl] = useState(null); // State for dropdown anchor

  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem
        icon={<Icon>podcasts</Icon>}
        title="Manage Podcast sessions"
      />
      <NotificationItem
        icon={<Icon>shopping_cart</Icon>}
        title="Payment successfully completed"
      />
    </Menu>
  );

  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    window.location.href = "https://portal.bzu.edu.pk/logout";
  };
  const handleSettings = () => {
    // console.log("Settings");
    navigate("/settings");
  };

  const handleAccountClick = (event) => {
    setAnchorEl(event.currentTarget); // Set anchor for dropdown
  };
  const handleClose = () => {
    setAnchorEl(null); // Close the dropdown
  };

  return (
    <>
      <AppBar
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) =>
          navbar(theme, { transparentNavbar, absolute, light, darkMode })
        }
        // sx={(theme) => ({background: "rgba(40, 22, 111, 0.11)",  })}
      >
        <Toolbar
          sx={(theme) => ({
            ...navbarContainer(theme),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            flexWrap: "nowrap",
          })}
        >
          {isMini ? null : (
            <>
              {/* Left: Menu Collapse Button */}
              <MDBox
                color={light ? "white" : "inherit"}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarMobileMenu}
                  onClick={handleMiniSidenav}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    {miniSidenav ? "menu_open" : "menu"}
                  </Icon>
                </IconButton>
              </MDBox>

              {/* Right: Icons */}
              <MDBox
                color={light ? "white" : "inherit"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  ml: "auto",
                }}
              >
                {/* <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  onClick={() => {
                    setOpenConfigurator(dispatch, !openConfigurator); // Toggle dark mode
                  }}
                >
                  <BedtimeOutlinedIcon
                    sx={{ width: "23px", height: "23px", fontSize: "23px" }}
                  />
                </IconButton> */}

                {/* <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  onClick={handleSettings}
                >
                  <SettingsIcon
                    sx={{ width: "23px", height: "23px", fontSize: "23px" }}
                  />
                </IconButton> */}
                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    window.open(user_manual, '_blank');
                                  }}
                                  sx={{ textTransform: "none", fontSize: "14px" }}
                                  style={{ color: "white"}}
                                  >
                                  Help / User Manual
                                </Button>
                  <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    window.location.href = "https://portal.bzu.edu.pk/";
                  }}
                  sx={{ textTransform: "none", fontSize: "14px" }}
                  style={{ color: "white"}}
                  >
                  Go to Main Dashboard
                </Button>
                <MDBox
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 1,
                    ml: "auto",
                  }}
                >
                  <IconButton
                    size="small"
                    color="inherit"
                    onClick={handleAccountClick}
                  >
                    <AccountCircleIcon
                      sx={{ width: "23px", height: "23px", fontSize: "23px" }}
                    />
                  </IconButton>
                  {/* Dropdown Menu */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem
                      onClick={handleLogout}
                      sx={{
                        fontSize: "14px",
                        p: "6px 12px",
                        justifyContent: "center",
                      }}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </MDBox>

                {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                <Icon sx={iconsStyle}>notifications</Icon>
              </IconButton> */}

                {/* Brightness Icon */}

                {renderMenu()}
              </MDBox>
            </>
          )}
        </Toolbar>
      </AppBar>
      {currentPath !== "/admin-dashboard" && (
        <BottomBar
          title="Admission System"
          homeText="Home"
          managementText={currentRouteName}
          sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} // Ensure BottomBar is fixed at the bottom
        />
      )}
    </>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
